export const API_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};

export const ENDPOINTS = {
  SITE_DETAILS: "/siteDetails",
  AWS: "/AWS",
  FILE_EXPLORER: "/fileExplorer",
  METRICS_DASHBOARD: "/metricsDashboard",
  JENKINS: "/jenkins",
  ORGANIZATIONS: "/organizations",
};
